
import React, { useEffect } from 'react'
import * as PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
// import { ButtonLink, Image } from 'components'
// import i18n from 'support/i18n'
// import DataProtection from 'components/data_protection/View'
// import UserDetailsForm from './components/user_details_form/View'
// import SignUpForm from './components/sign_up_form/View'
// import SignUpComplete from './components/sign_up_complete/View'
import styles from './View.Style'
import Registration from './Registration'

const SignUp = props => {
    return(
        // <p>sign up</p>
        <Registration />
    )
}

export default withStyles(styles)(SignUp)